import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import CpacValor from './cpacValor';
import ACCESS from '../../../ACCESS.js';

class CpacValores extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'cpacvalor/filter', deleteUrl: 'cpacvalor/delete', deleteField: 'rangoini', modUrl: '/Catalogo/CpacValor' },
      TableOp.Table('CPAC VALORES', [
        { label: 'Rangoini', id: 'rangoini' },
        { label: 'Cpac', id: 'cpac' },
        { label: 'Fecha de Actualización', id: 'updatedAt' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_CPAC.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_CPAC.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
          {
             
          <CpacValor  onSave={() => {this.table()}}></CpacValor>
        }
        {
           
          <this.TableRender  />
        }
        </div>
      </div>
    )
  }
}

export default withRouter(CpacValores)